import _classCallCheck from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module engine/view/observer/keyobserver
 */
import DomEventObserver from './domeventobserver.js';
import { getCode } from '@ckeditor/ckeditor5-utils';
/**
 * Observer for events connected with pressing keyboard keys.
 *
 * Note that this observer is attached by the {@link module:engine/view/view~View} and is available by default.
 */
var KeyObserver = /*#__PURE__*/function (_DomEventObserver) {
  _inherits(KeyObserver, _DomEventObserver);
  var _super = _createSuper(KeyObserver);
  function KeyObserver() {
    var _this;
    _classCallCheck(this, KeyObserver);
    _this = _super.apply(this, arguments);
    /**
     * @inheritDoc
     */
    _this.domEventType = ['keydown', 'keyup'];
    return _this;
  }
  /**
   * @inheritDoc
   */
  _createClass(KeyObserver, [{
    key: "onDomEvent",
    value: function onDomEvent(domEvt) {
      var data = {
        keyCode: domEvt.keyCode,
        altKey: domEvt.altKey,
        ctrlKey: domEvt.ctrlKey,
        shiftKey: domEvt.shiftKey,
        metaKey: domEvt.metaKey,
        get keystroke() {
          return getCode(this);
        }
      };
      this.fire(domEvt.type, domEvt, data);
    }
  }]);
  return KeyObserver;
}(DomEventObserver);
export { KeyObserver as default };